// src/services/feedbackApi.js
import apiService from './apiService';

const feedbackApi = {
  getAll: (params = {}) => apiService.get('/feedback', { params }),
  updateStatus: (id, status) => apiService.patch(`/feedback/${id}/status`, { status }),
  getPublicTestimonials: () => apiService.get('/feedback/testimonials'),
};

export default feedbackApi;
